/* eslint-disable no-invalid-this */
import {GenesisModal} from 'extensions/g-modal';
import styles from './diamond-modal.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

export class DiamondModal extends GenesisModal {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	constructor () {
		super();
	}

	async open (e) {
		await super.open(e);

		if (window.matchMedia('(min-width: 1170px)').matches) {
			setTimeout(() => {
				this.scrollIntoView({behavior: 'smooth'});
			}, 50);
		}
	}

};

defineCustomElement('rb-diamond-modal', DiamondModal);
